import CharacterAvatarPortrait from './CharacterAvatarPortrait';

export default CharacterAvatarPortrait;
export { CharacterAvatarPortrait };
